const htmlTemplates = {
    version1: (lang, title, headline, body) => `
 <html><head>
 <meta charset="UTF-8">
 <meta name="viewport" content="width=device-width, initial-scale=1.0">
 <title>Popup</title>
 <link href="https://fonts.googleapis.com/css?family=Poppins" rel="stylesheet">
 <style>
  body{
   font-family: 'Poppins';
   font-style: normal;
   margin: 0;
   padding: 0;
  }
  #popup {
   max-width: 350px;
   margin: 0 auto;
   
   box-sizing: border-box;
  }
  #popup img {
   max-width: 100%;
   height: auto;
   display: block;
   margin: 0 auto;
  }
  #popup h1 {
   font-size: 24px;
   font-weight: bold;
   text-align: center;
   margin: 0;
   padding: 0;
   line-height: 120%;
  }
  #popup p {
   font-size: 16px;
   text-align: center;
   margin: 20px 0;
   padding: 0;
   line-height: 24px;
  }
  @media only screen and (max-width: 768px) {
   #popup h1 {
    font-size: 28px;
   }
   #popup p {
    font-size: 14px;
   }
  }
 </style>
</head>
<body>
 <div class="container" id="popup">
  <img src="https://assets.userex.com/images/4/6248075d5ecb48491fff24a3f5e31cbd/uploadDocs.png" alt=" image">

    <h1>${headline}</h1>
      <p>${body}</p>
 </div>


</body></html>
    `,
    version2: (lang, title, headline, body) => `
  <html><head>
 <meta charset="UTF-8">
 <meta name="viewport" content="width=device-width, initial-scale=1.0">
 <title>Popup</title>
 <link href="https://fonts.googleapis.com/css?family=Poppins" rel="stylesheet">
 <style>
  body{
   font-family: 'Poppins';
   font-style: normal;
   margin: 0;
   padding: 0;
  }
  #popup {
   max-width: 350px;
   margin: 0 auto;
   
   box-sizing: border-box;
  }
  #popup img {
   max-width: 100%;
   height: auto;
   display: block;
   margin: 0 auto;
  }
  #popup h1 {
   font-size: 24px;
   font-weight: bold;
   text-align: center;
   margin: 0;
   padding: 0;
   line-height: 120%;
  }
  #popup p {
   font-size: 16px;
   text-align: center;
   margin: 20px 0;
   padding: 0;
   line-height: 24px;
  }
  @media only screen and (max-width: 768px) {
   #popup h1 {
    font-size: 28px;
   }
   #popup p {
    font-size: 14px;
   }
  }
 </style>
</head>
<body>
 <div class="container" id="popup">
    <h1>${headline}</h1>
      <p>${body}</p>
 </div>


</body></html>
    `,
 
  };
  
  export default htmlTemplates;
  